// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailContainer[data-v-7edf7ccc] {\n  height: calc(100vh - 40px);\n  overflow-y: auto;\n  padding: 20px;\n}\n.el-timeline[data-v-7edf7ccc] {\n  padding: 0;\n}\n.el-form-item[data-v-7edf7ccc] {\n  margin-bottom: 0;\n}\n.operationData .el-form-item__label[data-v-7edf7ccc],\n.operationData .el-form-item__content[data-v-7edf7ccc] {\n  line-height: 26px !important;\n}", ""]);
// Exports
module.exports = exports;
